const B2bRouting = {
  screens: {
    LoginScreen: 'login',
    // ResetPasswordScreen: "/forgot/reset/password",
    ResetPasswordScreen: 'set-password',
    PdfNavigator: {
      path: 'pdf-viewer',
      screens: {
        PdfScreen: '',
      },
    },
    HomeNavigator: {
      path: 'dashboard',
      screens: {
        HomeScreen: '',
      },
    },
    BusinessTrackerNavigator: {
      path: 'business-tracker',
      screens: {
        BusinessTrackerScreen: '',
        SalesmanDashboardScreen: '/salesman',
      },
    },
    BrandCatalogNavigator: {
      path: 'product-catalog',
      screens: {
        BrandCatalogScreen: '',
        ProductCatalogScreen: '/:id',
      },
    },
    CatalogNavigator: {
      path: 'catalog',
      screens: {
        CatalogScreen: '',
        CatalogBrandScreen: '/brand/:id',
        CatalogPromoScreen: '/promo/:id',
        CatalogCategoriesScreen: '/categories/:id',
      },
    },
    SalesOrderNavigator: {
      path: 'sales-order',
      screens: {
        SalesOrderScreen: '',
        SalesOrderDetailScreen: '/:id',
        SalesOrderDeliveryScreen: '/:id/delivery',
        SalesOrderInvoiceScreen: '/:id?/invoice',
        SalesOrderDocumentScreen: '/:id/document',
        SalesOrderFormScreen: '/form/page',
      },
    },
    ReturnOrderNavigator: {
      path: 'return-order',
      screens: {
        ReturnOrderScreen: '',
        ReturnOrderDetailScreen: '/:id',
        ReturnOrderDeliveryScreen: '/:id/delivery',
        ReturnOrderInvoiceScreen: '/:id/invoice',
        ReturnOrderDocumentScreen: '/:id/document',
        ReturnOrderFormScreen: '/form/page',
      },
    },
    LoyaltyPointNavigator: {
      path: 'loyalty-point',
      screens: {
        LoyaltySetupScreen: '',
      },
    },
    CustomerNavigator: {
      path: 'customer',
      screens: {
        CustomerScreen: '',
        CustomerDetailScreen: '/:id',
      },
    },
    LoyaltyNavigator: {
      path: 'customer-loyalty',
      screens: {
        LoyaltyScreen: '',
        LoyaltyDetailScreen: '/:id',
      },
    },
    CustomerRegisterNavigator: {
      path: 'customer-register',
      screens: {
        CustomerRegistrationScreen: '',
        //CustomerRegistrationScreen: "/edit/:id",
      },
    },
    PricelistNavigator: {
      path: 'pricelist',
      // Reconstruct the list beneath a deep-linked detail/form on web refresh,
      // so Back has a list to return to (no pop-error on refresh).
      initialRouteName: 'PricelistScreen',
      screens: {
        PricelistScreen: '',
        PricelistDetailScreen: '/add',
        PricelistEditScreen: '/edit/:id',
      },
    },
    BranchListNavigator: {
      path: 'branch-list',
      initialRouteName: 'BranchListScreen',
      screens: {
        BranchListScreen: '',
        BranchListDetailScreen: '/:id',
        BranchListFormScreen: '/form/page',
      },
    },
    UserNavigator: {
      path: 'users',
      screens: {
        UsersScreen: '',
        UserDetailScreen: '/:id',
        UserFormScreen: '/form/page',
      },
    },
    ProfileNavigator: {
      path: 'profile',
      screens: {
        ProfileScreen: '',
      },
    },
    MarketBusinessTypeNavigator: {
      path: 'market-business-type',
      initialRouteName: 'MarketBusinessTypeScreen',
      screens: {
        MarketBusinessTypeScreen: '',
        MarketBusinessTypeFormScreen: '/form',
      },
    },
    AccountGroupNavigator: {
      path: 'account-group',
      initialRouteName: 'AccountGroupScreen',
      screens: {
        AccountGroupScreen: '',
        AccountGroupFormScreen: '/form',
      },
    },
    SalesTeamNavigator: {
      path: 'sales-team',
      initialRouteName: 'SalesTeamScreen',
      screens: {
        SalesTeamScreen: '',
        SalesTeamDetailScreen: '/:id',
        SalesTeamFormScreen: '/form/page',
      },
    },
    PlanogramNavigator: {
      path: 'planogram',
      initialRouteName: 'PlanogramScreen',
      screens: {
        PlanogramScreen: '',
        PlanogramDetailScreen: '/:id',
        PlanogramFormScreen: '/form/page',
      },
    },
    TaskNotificationNavigator: {
      path: 'notifications',
      screens: {
        TaskNotificationScreen: '',
        TaskNotificationDetailScreen: '/:id',
      },
    },
    CalendarNavigator: {
      path: 'calendar',
      screens: {
        CalendarScreen: '',
      },
    },
    SalesActivityNavigator: {
      path: 'sales-activity',
      screens: {
        SalesActivityScreen: '',
        SalesActivityListScreen: '/lists',
      },
    },
    PromotionRulesNavigator: {
      path: 'promotion-rules',
      screens: {
        PromotionRulesScreen: '',
        PromotionRulesDetailScreen: '/:id',
        PromotionRulesFormScreen: '/form/page',
      },
    },
    CustomerClusterNavigator: {
      path: 'customer-cluster',
      screens: {
        CustomerClusterScreen: '',
        CustomerClusterDetailScreen: '/:id',
        CustomerClusterFormScreen: '/form/page',
      },
    },
    CustomerTypeNavigator: {
      path: 'customer-type',
      screens: {
        CustomerTypeScreen: '',
        CustomerTypeDetailScreen: '/:id',
        CustomerTypeFormScreen: '/form/page',
      },
    },
    MatrixApprovalNavigator: {
      path: 'matrix-approval',
      screens: {
        MatrixApprovalScreen: '',
        MatrixApprovalDetailScreen: '/:id',
      },
    },
    NewArrivalBestSellerNavigator: {
      path: 'new-arrival-best-seller',
      initialRouteName: 'NewArrivalBestSellerScreen',
      screens: {
        NewArrivalBestSellerScreen: '',
        NewArrivalBestSellerDetailScreen: '/:id',
        NewArrivalBestSellerFormScreen: '/form/page',
      },
    },
    CMSNavigator: {
      path: 'cms',
      initialRouteName: 'CMSScreen',
      screens: {
        CMSScreen: '',
        CMSDetailScreen: '/:id',
        CMSFormScreen: '/form/page',
      },
    },
    GuideBookNavigator: {
      path: 'guide-book',
      screens: {
        GuideBookScreen: '',
      },
    },
    BudgetPocketNavigator: {
      path: 'budget-pocket',
      screens: {
        BudgetPocketScreen: '',
        BudgetPocketDetailScreen: '/:id',
        BudgetPocketFormScreen: '/form/page',
      },
    },
    TargetSettingNavigator: {
      path: 'target-setting',
      screens: {
        TargetSettingScreen: '',
        TargetSettingUploadScreen: '/upload/:type/:targetType',
        TargetSettingApprovalScreen: '/approval/:type/:targetType',
      },
    },
    CoaTaxSettingNavigator: {
      path: 'coa-tax-setting',
      screens: {
        CoaTaxSettingScreen: '',
        CoaTaxSettingDetailScreen: '/:id',
        CoaTaxSettingFormScreen: '/form/page',
      },
    },
    SkpExternalNavigator: {
      path: 'skp-external',
      screens: {
        SkpExternalScreen: '',
        SkpExternalDetailScreen: '/:id',
        SkpExternalFormScreen: '/form/page',
        SkpExternalListScreen: '/external',
      },
    },
    SkpInternalNavigator: {
      path: 'skp-internal',
      screens: {
        SkpInternalScreen: '',
        SkpInternalDetailScreen: '/:id',
        SkpInternalFormScreen: '/form/page',
        SkpInternlBudgetTableScreen: '/table',
        SkpExternalListScreen: '/external',
      },
    },
    CreditLimitNavigator: {
      path: 'credit-limit',
      screens: {
        CreditLimitScreen: '',
        CreditLimitDetailScreen: '/:id',
        CreditLimitFormScreen: '/form/page',
      },
    },
    LPBNavigator: {
      path: 'lembar-penerimaan-barang',
      screens: {
        LPBScreen: '',
        LPBDetailScreen: '/:id',
        LPBFormScreen: '/form/page',
      },
    },
    InventoryNavigator: {
      path: 'inventory',
      screens: {
        InventoryScreen: '',
        InventorySummaryDetailScreen: '/summary/:id',
        InventorySummaryScreen: '/summary',
        InventoryDetailScreen: '/:id',
        InventoryFormScreen: '/form/page',
      },
    },
    ForecastStockNavigator: {
      path: 'forecast-stock',
      screens: {
        ForecastStockScreen: '',
        ForecastStockDetailScreen: '/:id',
      },
    },
    SubdistributorNavigator: {
      path: 'subdistributor',
      screens: {
        SubdistributorScreen: '',
        SubdistributorDetailScreen: '/:id',
        SubdistributorFormScreen: '/form/page',
      },
    },
    RequestProductNavigator: {
      path: 'request-product',
      screens: {
        RequestProductListScreen: '/request-products',
        RequestProductDetailScreen: '/request-products/detail/:id',
        RequestProductFormScreen: '/request-products/form',
        RequestProductPeriodScreen: '/period',
        RequestProductListingScreen: '/product-listing',
        RequestProductListingDetailScreen: '/product-listing/:id',
        RequestProductListingFormScreen: '/product-listing/form',
      },
    },
    ProductStockNavigator: {
      path: 'product-stock',
      screens: {
        ProductStockScreen: '',
      },
    },
    BrandNavigator: {
      path: 'brand',
      screens: {
        BrandScreen: '',
        BrandDetailScreen: '/:id',
      },
    },
    PromotionAccountNavigator: {
      path: 'promotion-account',
      initialRouteName: 'PromotionAccountScreen',
      screens: {
        PromotionAccountScreen: '',
        PromotionAccountFormScreen: '/form',
      },
    },
    NotFound: '/404',
  },
};

export default B2bRouting;
